import FormHandler from "formhandler.js";

export default {
    init() {
        const couponCodeSubmit = document.querySelector(".js-coupon-code-submit");

        couponCodeSubmit.addEventListener('click', function(event) {
                event.preventDefault();
            }
		);
		
        this.handleForm();
    },

    handleForm() {
        const $this = this;
        const couponCodeFormHandler = new FormHandler({
            form: {
                block: ".js-coupon-code-form",
                submit: ".js-coupon-code-submit",
                delayForNotice: 100000,
                notice: {
                    appendTo: ".js-coupon-code-notices",
                    message: "Form is invalid. Please check your details and try again.",
                    succesMessage: "Form successfully sent.",
                    errorMessage: "Oops, something went wrong. Please try again later.",
                }
            },
            fields: {
                "coupon": {
                    validation: "isNonEmpty"
				},
				user_id: {
					validation: "isNonEmpty"
				}
			},
			callbacks: {
				onSubmit(form, fields) {
					testValidity(form);
				},
			},
        });

        function testValidity(form) {
            if(couponCodeFormHandler.isFormValid() === true) {
                $this.submit(form);
            }
        }

    },

    submit(form) {
        form.submit()
    }
};
